<template>
    <div>
        <div class="mains">
            <div class="content">
                <div class="tittle-lv1">企业激活</div>
                <Form :model="formRight" :label-width="144" :rules="ruleValidate" @keyup.enter="activation">
                    <div class="mTop">
                        <p>主体信息</p>
                        <FormItem label="企业全称" prop="cname">
                            <Input v-model="formRight.cName" disabled></Input>
                        </FormItem>
                        <FormItem label="营业执照注册号" prop="cNumber">
                            <Input v-model="formRight.cNumber" placeholder="请输入正确的营业执照注册号"></Input>
                        </FormItem>
                        <!--营业执照图片上传-->
                        <FormItem label="营业执照" prop="name">
                            <div style="display: flex;">
                                <div @click="showLicense" style="background:#bbbec4;height: 140px;width: 120px;">
                                    <img style="height: 140px;width: 120px;" alt="上传营业执照" :src="license">
                            </div>
                                <div style="margin-left: 15px;">
                                    <viewer :images="images" style="display: none" ref="images">
                                        <img v-for="src in images" :src="src" :key="src">
                                    </viewer>
                                    <div @click="show" style="color:#3399ff;cursor: pointer;">查看示例</div>
                                    <div style="color:#9ea7b4">请确保图片完整清晰，不带与审核无关水印，黑白副本需盖上鲜章</div>
                                    <Upload
                                        ref="upload"
                                        :show-upload-list="false"
                                        :on-success="handleSuccess"
                                        multiple
                                        action="//api.unionnet.com/api/file/uploadimg">
                                        <Button type="ghost" icon="ios-cloud-upload-outline">上传营业执照</Button>
                                    </Upload>
                                </div>
                            </div>
                        </FormItem>
                    </div>
                    <div class="mTop">
                    <p>法人代表信息</p>
                    <FormItem label="法人姓名" prop="fname">
                        <Input v-model="formRight.fname" placeholder="请填写公司法人姓名"></Input>
                    </FormItem>
                    <FormItem label="法人手机" prop="fMobile">
                        <Input v-model="formRight.fMobile" placeholder="请填写管理员手机号"></Input>
                    </FormItem>
                    <!--身份证正反面图片上传-->
                    <FormItem label="法人身份证照片" prop="mobile">
                        <div  style="display: flex;flex-direction: row;margin-bottom: 10px">正面：
                            <Upload ref="upload"
                                    :show-upload-list="false"
                                    :on-success="justHandleSuccess"
                                    multiple
                                    action="//api.unionnet.com/api/file/uploadimg">
                                <Button type="ghost" icon="ios-cloud-upload-outline">上传图片</Button>
                            </Upload>
                        </div>

                        <div  class="imageTitle">
                            <div v-if="!justLicense" class="imagesNo">未上传图片</div>
                            <div v-if="justLicense" class="imagesNo" @click="showJust">
                                <img style="width: 220px;height: 140px;"  :src="justLicense" alt=""></div>
                            <div class="imageExp">
                                <div>示例</div>
                                <div>
                                    <img style="height: 105px;" src="http://api.unionnet.com/images/upload_img_2.gif" alt="">
                                </div>
                            </div>
                        </div>
                        <div  class="imageTitle">反面：
                            <!--<Upload action="http://api.root.com/api/file/uploadimg">-->
                            <Upload ref="upload"
                                    :show-upload-list="false"
                                    :on-success="backHandleSuccess"
                                    multiple
                                    action="//api.unionnet.com/api/file/uploadimg">
                                <Button type="ghost" icon="ios-cloud-upload-outline">上传图片</Button>
                            </Upload>
                        </div>
                        <div style="display: flex;flex-direction: row;">
                            <div v-if="!backLicense" class="imagesNo">未上传图片</div>
                            <div v-if="backLicense" class="imagesNo" @click="showBack">
                                <img style="width: 220px;height: 140px;"  :src="backLicense" alt=""></div>
                            <div class="imageExp">
                                <div>示例</div>
                                <div>
                                    <img style="height: 105px;" src="http://api.unionnet.com/images/upload_img_2_1.gif" alt="">
                                </div>
                            </div>
                        </div>
                    </FormItem>
                </div>
                    <div class="mTop">
                        <p>管理员信息</p>
                        <FormItem label="管理员姓名" prop="fullname">
                            <Input v-model="formRight.fullname" disabled placeholder="请填写创建人的姓名"></Input>
                        </FormItem>
                        <FormItem label="管理员手机" prop="mobile">
                            <Input v-model="formRight.mobile" disabled placeholder="请填写管理员手机号"></Input>
                        </FormItem>
                        <FormItem label="验证码" prop="code">
                            <Input v-model="formRight.code" style="width: 200px" placeholder="请输入手机短信收到的6位验证码"
                                   :maxlength="6"></Input>
                            <a v-if="countdown" style="margin-left:10px;">{{countdown}}</a>
                            <a v-else style="margin-left:10px;" @click="getAuthCode">获取验证码</a><br>
                        </FormItem>
                    </div>
                    <div style="text-align:center;color:#ccc;margin-top: 10px;">
                        <CheckboxGroup>
                            <Checkbox v-model="agree" label="我同意并遵守《易采智电客户端服务协议》"></Checkbox>
                            <Button type="primary" :disabled="!agree||!msgCheck" style="vertical-align: middle"
                                    @click="activation">激活
                            </Button>
                        </CheckboxGroup>
                    </div>
                </Form>
            </div>
        </div>
        <div class="footer">
            &copy;易采智电
            <!--<div class="layout-content footer-content">-->
            <!--<dl>-->
            <!--<dt>关于我们</dt>-->
            <!--<dd>公司介绍</dd>-->
            <!--<dd>客户案例</dd>-->
            <!--<dd>上午合作</dd>-->
            <!--<dd>联系我们</dd>-->
            <!--</dl>-->
            <!--<dl>-->
            <!--<dt>产品资料</dt>-->
            <!--<dd>产品介绍</dd>-->
            <!--<dd>基础实用手册</dd>-->
            <!--<dd>管理员手册</dd>-->
            <!--<dd>官方指南</dd>-->
            <!--</dl>-->
            <!--<dl>-->
            <!--<dt>服务规则</dt>-->
            <!--<dd>服务条款</dd>-->
            <!--<dd>技术支持</dd>-->
            <!--</dl>-->
            <!--<dl>-->
            <!--<dt>下载易采智电</dt>-->
            <!--<dd>下载客户端</dd>-->
            <!--<dd>企业注册易采智电</dd>-->
            <!--</dl>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    import ruleValidate from '../../validator'
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)


    export default {
        name: 'activation',
        data() {
            return {
                formRight: {
                    fname: '',
                    fullname: '',
                    mobile: '',
                    code: '',
                    fMobile:'',
                    cName:'',
                    cNumber:''
                },
                images: ['http://api.root.com/images/license.png'],
                images1: ['http://api.root.com/images/upload_img_2.gif'],
                images2: ['http://api.root.com/images/upload_img_2_1.gif'],
                modal3:false,
                countdown: 0,
                msgCheck: true,
                agree: false,
                uploadList: [],
                imgName: '',
                license:'http://api.unionnet.com/images/Business-license.png',
                licenseFileid: '',
                justLicense:'',
                justFileid:'',
                backLicense:'',
                backFileid:''
            }
        },
        computed: {
            ruleValidate: function () {
                return ruleValidate
            }
        },
        mounted(){
            this.companyShow();
        },
        methods: {
            //企业详情
            companyShow(){
                this.$http.get(this.$api.SIGNIN+"/"+this.$store.getters.userInfo.com_id)
                .then(res => {
                    if(res.data.status === '1'){
                        var data = res.data.data;
                        this.formRight.cName = data.com_name;
                        this.formRight.fullname = data.contact;
                        this.formRight.mobile = data.mobile;
                        this.formRight.fname =  data.fname;
                        this.formRight.fMobile = data.fmobile;
                        this.formRight.cNumber = data.signNumer;
                        this.license = 'http://api.unionnet.com/'+data.licenseSrc;
                        this.justLicense = 'http://api.unionnet.com/'+data.justSrc;
                        this.backLicense = 'http://api.unionnet.com/'+data.backSrc;
                        this.licenseFileid = data.licenseFileid;
                        this.justFileid = data.justFileid;
                        this.backFileid = data.backFileid;
                    }else{
                        console.log(222);
                    }
                })
            },
            //去首页
            toIndex(){
                this.$router.push('/home')
            },

            //营业执照示例图片详情
            show () {
                this.images = [];
                this.images.push('http://api.root.com/images/license.png');
                let vm = this
                setTimeout(()=>{
                    const viewer = vm.$refs.images.$viewer
                    viewer.show()
                },100)
            },

            //上传成功
            handleSuccess (res, file) {
                this.license = 'http://api.unionnet.com/'+res.url[0];
                this.licenseFileid = res.fileid;
            },

            //营业执照图片详情
            showLicense(){
                this.images = [];
                this.images.push(this.license);
                let vm = this
                setTimeout(()=>{
                    const viewer = vm.$refs.images.$viewer
                    viewer.show()
                },100)
            },

            //身份证正面上传
            justHandleSuccess(res){
                this.justLicense = 'http://api.unionnet.com/'+res.url[0];
                this.justFileid = res.fileid;
            },

            //身份证正面图片详情
            showJust(){
                this.images = [];
                this.images.push(this.justLicense);
                let vm = this
                setTimeout(()=>{
                    const viewer = vm.$refs.images.$viewer
                    viewer.show()
                },100)
            },

            //身份证正面上传
            backHandleSuccess(res){
                this.backLicense = 'http://api.unionnet.com/'+res.url[0];
                this.backFileid = res.fileid;
            },

            //身份证正面图片详情
            showBack(){
                this.images = [];
                this.images.push(this.backLicense);
                let vm = this
                setTimeout(()=>{
                    const viewer = vm.$refs.images.$viewer
                    viewer.show()
                },100)
            },

            //发生短信验证码
            getAuthCode() {
                if (this.formRight.mobile.length !== 11) {
                    return false
                }
                this.countdown = 60;
                let _this = this;
                let timer = setInterval(function () {
                    _this.countdown--;
                    _this.countdown < 1 ? clearInterval(timer) : ''
                }, 1000);
                this.$http.get(this.$api.GET_MSG + '?mobile=' + this.formRight.mobile).then(res => {
                    console.log('短信', res);
                }, err => {
                    this.$Message.error('网络错误');
                });
            },

            //表单提交
            activation() {
                if (this.formRight.code.length === 6) {
                    this.$http.get(this.$api.CONFIRM_MSG + '?mobile=' + this.formRight.mobile + '&code=' + this.formRight.code).then(res => {
                        console.log('信息验证', res);
                        if (res.data.status === 1) {
                            this.$Message.success('验证码正确');
                            if (!this.agree) {
                                return false
                            }
                            this.$Loading.start();
                            this.$http.post(this.$api.ACTIVATION, {
                                fMobile:this.formRight.fMobile,
                                cName:this.formRight.cName,
                                cNumber:this.formRight.cNumber,
                                fname: this.formRight.fname,
                                code: this.formRight.code,
                                fullname: this.formRight.fullname,
                                mobile: this.formRight.mobile,
                                backFileid:this.backFileid,
                                justFileid:this.justFileid,
                                licenseFileid:this.licenseFileid,
                                com_id: this.$store.getters.userInfo.com_id,
                            })
                            .then(res => {
                                if (res.data.status === '1') {
                                    this.$router.push('mains')
                                    this.$Message.success('激活成功');
                                } else {
                                    this.$Message.error(res.data.msg);
                                }
                            }, err => {
                                this.$Message.error('网络错误');
//                                this.$router.push('mains')
                            })
                        } else {
                            this.$Message.error('验证码错误');
                        }
                    }, err => {
                        this.$api.errcallback(err)
                    });
                }

            },
        }
    }
</script>

<style scoped>
    .layout-content {
        /*width: 1080px;*/
        margin: 0 auto;
    }

    .layout-top {
        width: 100%;
        height: 60px;
        background: #fff;
        border-bottom: 1px solid #ccc;
        margin-bottom: 0;
    }

    .layout-logo {
        width: 100px;
        height: 30px;
        background-image: url('../../assets/logo.png');
        background-repeat: no-repeat;
        background-size: contain;
        /*background-color: #5b6270;*/
        border-radius: 3px;
        position: relative;
        top: 15px;
        left: 0px;
    }

    .loginIn {
        margin-top: 14px;
        margin-right: 20px;
    }

    .mains {
        background-color: #F9F9F9;
        padding-top: 20px;
        overflow: hidden;
    }

    .content {
        width: 780px;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 4px;
        padding: 40px;
        margin-bottom: 30px;
    }

    .content:hover {
        box-shadow: 1px 0px 2px #ccc;
    }

    .tittle-lv1 {
        text-align: center;
        font-weight: 600;
    }

    .content i {
        position: absolute;
        top: 28px;
        left: 10px;
        font-style: normal;
        color: #ccc;
    }

    .content p {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 20px;
    }

    .footer {
        width: 100%;
        height: 188px;
        background-color: #303036;
        overflow: hidden;
        color: #ccc;
        font-size: 14px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;

    }

    .footer .footer-content {
        width: 30%;
        margin: 20px auto;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-around;
    }

    .mTop {
        padding: 26px 74px;
        padding-bottom: 0;
        border-bottom: 1px solid #DCE1E6;
    }

    .layout-content dl {
        display: inline-block;
        width: 15%;
        vertical-align: top;
        line-height: 2;
    }

    .layout-content dt {
        color: #fff;
        font-size: 14px;
    }

    .layout-content dd {
        color: #aaa;
    }
    .imagesNo {
        width: 220px;
        border:1px solid #dddee1;
        height: 140px;
        text-align: center;
        line-height: 140px
    }
    .imageTitle {
        display: flex;
        flex-direction: row;
        margin-bottom: 10px;
    }
    .imageExp{
        width: 140px;
        height: 140px;
        margin-left: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/activation/activation.vue